import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { FormsModule } from '@angular/forms';   
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core'; 
import { SettingsOffcanvasComponent } from '../settings-offcanvas.component';

@Component({
  selector: 'app-personal-info',
  imports: [
    CommonModule,
    FormsModule,   
    TranslateModule,
    SettingsOffcanvasComponent
  ],
  templateUrl: './personal-info.component.html',
  styleUrl: './personal-info.component.css'
})
export class PersonalInfoComponent {

}
